import React from 'react'
import SkeletonBlock from './SkeletonBlock'

/**
 * Round avatar placeholder. Default size matches the 32px (w-8 h-8) avatar
 * used in CompactGroupCard / Friends list rows.
 */
function SkeletonAvatar({ size = 'w-8 h-8' }) {
  return <SkeletonBlock className={`${size} rounded-full`} />
}

export default SkeletonAvatar
